import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex md:flex-row flex-col items-center md:space-x-3 md:space-y-0 space-y-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Save Changes", -1)
const _hoisted_3 = { class: "mt-6 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_4 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_5 = { class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded" }
const _hoisted_6 = { class: "flex items-center justify-between" }

import { ref, computed, watch} from "vue";
 import UserLayout from "@/layouts/UserLayout.vue";
 import SectionTitle from "@/components/partials/SectionTitle.vue";
 import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
 import SuccessModal from "@/components/modals/SuccessModal.vue";
 import FormSection from "./FormSection.vue";
 import { useRouter, useRoute } from "vue-router";
 import { renderSelect, renderSelectV2 } from "@/interfaces/DropdownInterface"; 
 import { errorResponse } from "@/helpers/errorMessage";
 import pickBy from "lodash/pickBy";
 import PageLoader from "@/components/loaders/PageLoader.vue"
 import { useRecordStatusChecker } from "@/store/recordStatusChecker";
 import { onIonViewWillEnter } from "@ionic/vue";
 /******************************* For Offline Imports************************************ */
 import { useNetworkStore } from "@/store/network";
 import CasePatientAddressForm from "@/classes/Cases/CasePatientAddress/Offline/Formatters/CasePatientAddressForm";
 import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
 import Rules from "@/classes/Cases/CasePatientAddress/Offline/Validation/Rules";
 import CasePatientAddressService from "@/classes/Cases/CasePatientAddress/CasePatientAddressService";
 import PatientAddressCreate from "@/classes/Cases/CasePatientAddress/Offline/Interface/CasePatientInterface";
 import useVuelidate from "@vuelidate/core";
 import CasePatientAddressOfflineProcessor from "@/classes/Cases/CasePatientAddress/Offline/Processor/OfflineProcessor";
 import OnlineSynching from "@/classes/Synching/OnlineSynching";
 
export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

 const { createRules } = Rules;
 const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
 /*************************************************************************************** */
 
 
 const router = useRouter();
 const route = useRoute();
 const showSuccess = ref<boolean>(false);
 const loading = ref<boolean>(false);
 const patientId = ref<number | null>(route.params.patient);
 const caseId = ref<number | null>(route.params.case);
 const patientAddressId = ref<number | null>(route.params.patientAddress);
 const regions = ref<renderSelect[]>([]);
 const cities = ref<renderSelect[]>([]);
 const provinces = ref<renderSelect[]>([]);
 const barangays = ref<renderSelect[]>([]);
 const residenceTypes = ref<renderSelectV2[]>([]);
 
 
 //This form used by both online and offline
 const form = ref<PatientAddressCreate>(CasePatientAddressForm.updateForm({}));
 
 
 const errors = ref<object>({});
 const successMessage = ref<string>("Patient address details has been updated");
 const patient = ref<string>("");
 const loaded = ref<boolean>(false);
 const intakeParams = ref<string>(route.query.intake);
 const recordStatusChecker = useRecordStatusChecker();
 const onlineSync = new OnlineSynching();
 
 
 /**
 * Validate the form using Vuelidator
 */
 const validateForm = () =>{
	const vuelidate = useVuelidate(createRules({...form.value}), form.value)
	const result = vuelidate.value.$validate();
 
 
	result
		.then((res) => {
			if(res) {
				save()
			} else {
				errors.value = ErrorValidation.getErrors(vuelidate.value)
                errorResponse(errors.value);
			}
		})
 }
 
 
 
 
 const save = async (): Promise<any> => {
	errors.value = {};
 
 
	const response = await CasePatientAddressService.update(
		patientId.value,
		caseId.value,
		patientAddressId.value,
		{ ...form.value },
		isNetworkAvailable.value
	);
 
 
	if (response?.status === 200 || response?.data != undefined) {
        if (isNetworkAvailable.value) {
            await CasePatientAddressOfflineProcessor.syncToOffline(caseId.value, response.data.data.item);
        }

		setTimeout(() => {
			recordStatusChecker.isCreatedPatientAddress = true;
			showSuccess.value = true;
			successMessage.value = response.data.message;
			loading.value = false;
		}, 500);
	} else {
		const error = response;
		errors.value = errorResponse(error.response?.data?.errors);
	}
 };
 const redirectSuccess = async (): void => {
	showSuccess.value = false;
	if (intakeParams.value) {
		router.replace(
			`/patient/${patientId.value}/cases/${caseId.value}/intake/address-present-location`
		);
	} else {
		router.replace(`/patient/${patientId.value}/cases/${caseId.value}/edit`);
	}
 };
 
 
 const getData = async (): Promise<any> => {
	const response = await CasePatientAddressService.edit(
		patientId.value,
		caseId.value,
		patientAddressId.value,
		pickBy({}),
		isNetworkAvailable.value
	);

    if (response?.response?.status === 404) {
        loaded.value = true;
        return;
    }
   
	if (response?.status === 200 || response?.data != undefined) {
		form.value = CasePatientAddressForm.updateForm(response.data.item);
		patient.value = response.data.patient;
		residenceTypes.value = response.data.residenceTypes;
		
	if(!isNetworkAvailable.value){
			form.value = CasePatientAddressForm.updateForm(response.data.item[0]);
		}

        if (isNetworkAvailable.value) {
            await CasePatientAddressOfflineProcessor.syncToOffline(caseId.value, response.data.item);
        }
        
		loaded.value = true;
	}
 };

 watch(
    () => isNetworkAvailable.value,
    async () => {
        loaded.value = false;
        await getData();
        await onlineSync.checkDrafts();
    }
)

 onIonViewWillEnter(async () => {
	recordStatusChecker.isCreatedPatientAddress = false;
	await getData();
    await onlineSync.checkDrafts();
 });
 
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit`,
    hasBackClass: "flex md:justify-between md:items-center md:flex-row flex-col"
  }, {
    lowerRight: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
						_unref(router).push(
							`/patient/${patientId.value}/cases/${caseId.value}/edit`
						)
					)),
          class: "md:w-auto w-full md:mt-0 mt-6"
        }, [
          _createVNode(ButtonComponent, {
            btnWidth: "quinary",
            customClass: "quinary md:w-auto w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          })
        ]),
        _createVNode(ButtonComponent, {
          customClass: "primary md:w-auto w-full md:mt-0 mt-6",
          form: "form",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (validateForm()))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_4, _toDisplayString(patient.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SectionTitle, { title: "Address Details" })
        ]),
        (loaded.value)
          ? (_openBlock(), _createBlock(FormSection, {
              key: 0,
              form: form.value,
              errors: errors.value,
              regions: regions.value,
              provinces: provinces.value,
              cities: cities.value,
              barangays: barangays.value,
              residenceTypes: residenceTypes.value,
              "onUpdate:form": _cache[2] || (_cache[2] = (value) => form.value = value)
            }, null, 8, ["form", "errors", "regions", "provinces", "cities", "barangays", "residenceTypes"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Record Save!",
        content: successMessage.value
      }, null, 8, ["show", "content"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})